import React from "react";
import BaseLayout from "../../components/layout/BaseLayout";
import { BsPeopleFill } from "react-icons/bs";

const Retentions = () => {
    return (
        <BaseLayout>
            <div className="flex flex-col items-center justify-center w-full h-full gap-6">
                <div className="flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-orange-500/20 to-amber-500/20 border br-1">
                    <BsPeopleFill className="text-4xl text-orange-400" />
                </div>
                <div className="text-center">
                    <h1 className="text-3xl font-bold p-text mb-2">Retentions</h1>
                    <p className="text-lg s-text max-w-md">
                        Customer retention and churn analytics coming soon.
                    </p>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-1 border br-1">
                    <div className="w-2 h-2 rounded-full bg-yellow-500 animate-pulse"></div>
                    <span className="text-sm s-text">Under Development</span>
                </div>
            </div>
        </BaseLayout>
    );
};

export default Retentions;
